// extracted by mini-css-extract-plugin
module.exports = {"paymentButton":"PaymentMessage_paymentButton__1gYZ-","remainingTime":"PaymentMessage_remainingTime__AJUn1","wrapper":"PaymentMessage_wrapper__1ItD0"};